import type { AdminLabRow } from "../../services/labService";
import { AdminLabsListRow } from "./AdminLabsListRow";

interface AdminLabsListProps {
  labs: AdminLabRow[];
  showTypeBadge: boolean;
  busyLabIds: Record<string, boolean>;
  onOpenMembers: (lab: AdminLabRow) => void;
  onManageAuditor: (lab: AdminLabRow) => void;
  onJoin: (labId: string) => Promise<void>;
  onLeave: (labId: string) => Promise<void>;
  onRemove: (lab: AdminLabRow) => void;
}

export const AdminLabsList = ({
  labs,
  showTypeBadge,
  busyLabIds,
  onOpenMembers,
  onManageAuditor,
  onJoin,
  onLeave,
  onRemove,
}: AdminLabsListProps) => {
  return (
    <div className="divide-y divide-[#eaddc9]">
      {labs.map((lab) => (
        <AdminLabsListRow
          key={lab.id}
          lab={lab}
          showTypeBadge={showTypeBadge}
          isBusy={Boolean(busyLabIds[lab.id])}
          onOpenMembers={onOpenMembers}
          onManageAuditor={onManageAuditor}
          onJoin={onJoin}
          onLeave={onLeave}
          onRemove={onRemove}
        />
      ))}
    </div>
  );
};